import React from 'react';

const CboFamiliar = ({ selectedValue, onChange, disabled }) => {
  return (
      <select className="form-control form-select mb-3 " value={selectedValue} onChange={onChange} disabled={disabled} >
       
        <option value="1">Padre</option>
        <option value="2">Madre</option>
        <option value="3">Tutor</option>
        <option value="4">Responsable</option>   
      </select>
  );
};

export default CboFamiliar;